module.exports = __webpack_public_path__ + "media/soundtrack.97a97a87.mp3";